module.exports = __webpack_public_path__ + "static/media/ClipboardText.3f5d6614.svg";